import React, {Component} from 'react'
import {CardElement, injectStripe} from 'react-stripe-elements'
import {Modal} from 'antd'

class StripeComponent extends Component {
  submit = async () => {
    let {token} = await this.props.stripe.createToken({name: 'Name'})
    this.props.onOk(token.id)
  }

  render() {
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.props.onCancel}
        confirmLoading={this.props.confirmLoading}
      >
        <CardElement/>
      </Modal>
    )
  }
}

export default injectStripe(StripeComponent)
